(function () {
    const preferences = ['system', 'light', 'dark'];
    const labels = {
        system: 'Darstellung: System',
        light: 'Darstellung: Hell',
        dark: 'Darstellung: Dunkel'
    };
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const buttons = document.querySelectorAll('[data-theme-toggle]');

    function getPreference() {
        const preference = document.documentElement.dataset.themePreference;
        return preferences.includes(preference) ? preference : 'system';
    }

    function updateTextContrast() {
        const color = getComputedStyle(document.documentElement).getPropertyValue('--background-color').trim();
        const match = color.match(/^#([\da-f]{3}|[\da-f]{6})$/i);
        let hasLightText = document.documentElement.dataset.theme === 'dark';

        if (match) {
            const hex = match[1].length === 3
                ? match[1].split('').map(function (character) { return character + character; }).join('')
                : match[1];
            const red = parseInt(hex.slice(0, 2), 16);
            const green = parseInt(hex.slice(2, 4), 16);
            const blue = parseInt(hex.slice(4, 6), 16);
            hasLightText = ((red * 299) + (green * 587) + (blue * 114)) / 1000 < 128;
        }

        document.documentElement.classList.toggle('has-light-text', hasLightText);
        document.documentElement.classList.toggle('has-dark-text', !hasLightText);
    }

    function applyPreference(preference, persist) {
        const theme = preference === 'system' ? (media.matches ? 'dark' : 'light') : preference;
        document.documentElement.dataset.theme = theme;
        document.documentElement.dataset.themePreference = preference;
        updateTextContrast();

        if (persist) {
            try {
                localStorage.setItem('color-scheme', preference);
            } catch (error) {
                // The selected mode still applies for this page if storage is unavailable.
            }
        }

        buttons.forEach(function (button) {
            button.setAttribute('aria-label', labels[preference]);
            button.setAttribute('title', labels[preference]);
        });
    }

    buttons.forEach(function (button) {
        button.addEventListener('click', function () {
            const currentIndex = preferences.indexOf(getPreference());
            applyPreference(preferences[(currentIndex + 1) % preferences.length], true);
        });
    });

    media.addEventListener('change', function () {
        if (getPreference() === 'system') {
            applyPreference('system', false);
        }
    });

    applyPreference(getPreference(), false);
}());
